// 登陆页
const login = {
  key_boyanIoTqiyeguanlipingtai: "场景应用中心",
  key_zanwuquanxian: "暂无权限",
  key_xuanzechangjing: "选择场景",
  key_zhanghao: "账号",
  key_mima: "密码",
  key_denglu: "登录",
  key_jizhuzhanghaomima: "记住密码",
  key_wangjimima: "忘记密码？",
  key_quzhuce: "去注册",
  key_xitongyichang: "系统异常",
  key_bushikehu: "不是客户？",
  key_mianfeishiyong: "免费试用",
  key_qingshuruyonghuming: "请输入用户名",

  //注册页
  key_zhuce: "注册",
  key_zhucechenggong: "注册成功",
  key_gongsimingcheng: "公司名称",
  key_suozaiquyu: "所在区域",
  key_changjingleixing: "场景类型",
  key_lianxirenmingcheng: "联系人名称",
  key_lianxidianhua: "联系电话",
  key_zhiweimingcheng: "职位名称",
  key_youxiang: "邮箱",
  key_youxiangyanzhengma: "邮箱验证码",
  key_zhanghumima: "账户密码",
  key_querenmima: "确认密码",
  key_yanzhengmafasongdaoyouxiang: "您的验证码已发送至您的邮箱",
  key_qingquerenmima: "请确认密码",
  key_fasongyanzhengma: "发送验证码",
  key_qingshuruzhengqueyouxianggeshi: "请输入正确的邮箱格式",
  key_qingshuruzhengquemimageshi: "请输入正确的密码格式",
  key_mimabuyizhi: "两次密码不一致",
  //注册成功
  key_nindexinxiyitijiao: "您的信息已提交",
  key_yigegongzuorineiwancheng: "1个工作日内将完成审核",
  key_ruyouwentiqinglianxi: "如有问题，请联系 400-000-6282",
  key_tijiaochenggong: "提交成功!",

  //找回密码
  key_zhaohuimima: "找回密码",
  key_forgetwarning1: "请填写您需要找回的账号，按提示步骤找回密码",
  key_xinmima: "新密码",
  key_mimachongzhichenggong: "恭喜，租户管理后台的账号重置密码成功！",
  key_zhijiedenglu: "直接登录",
  key_mimaxiugaichenggong: "密码修改成功"
};

// 头部导航栏
const headerLang = {
  key_xiangmugaikuang: "项目概况",
  key_shebeiguanli: "设备管理",
  key_nenghaoguanli: "能耗管理",
  key_baojingguanli: "报警管理",
  key_weibaoguanli: "维保管理",
  key_yonghuguanli: "用户管理",
  key_yunweitongzhi: "运维通知",
  key_kongzhitai: "控制台",
  key_gerenxinxi: "个人信息",
  key_xiugaimima: "修改密码",
  key_gengxingongsixinxi: "更新公司信息",
  key_gexingpeizhi: "个性配置",
  key_jueseguanli: "角色管理",
  // 默认值
  key_zuhuguanlihoutai: "租户管理后台",
  key_zanwuyingyong: "暂无应用",
  key_xingqiyi: "星期一",
  key_xingqier: "星期二",
  key_xingqisan: "星期三",
  key_xingqisi: "星期四",
  key_xingqiwu: "星期五",
  key_xingqiliu: "星期六",
  key_xingqiri: "星期日",
  //空气质量
  key_huanjingshuju: "环境数据",
  key_shuxing: "属性",
  key_kongqizhiliang: "空气质量",
  key_sheweimoren: "设为默认",
  key_wendu: "温度",
  key_shidu: "湿度"
};

// 左侧导航栏
const Aside = {
  // 设备
  key_shebeizonglan: "设备总览",
  // 能耗
  key_zongnenghaotongji: "总能耗统计",
  key_yongshuitongji: "用水统计",
  key_yongdiantongji: "用电统计",
  // 报警
  key_shishibaojing: "实时报警",
  key_baojingfenxi: "报警分析",
  key_baojingdingyi: "报警定义",
  // 维保

  // 用户
  key_shouye: "员工管理",
  key_shouye: "员工列表",
  // 运维
  key_shouye: "发布历史",
  key_shouye: "发布通知",
  // 空间
  key_shouye: "组织架构配置",
  key_shouye: "空间配置",
  key_shouye: "岗位类型配置",
  key_shouye: "水电费配置",

  key_shouye: "首页",
  key_yuangongguanli: "员工管理",
  key_yuangongshouquanjilu: "员工授权记录",
  key_fangkeguanli: "访客管理",
  key_fangkexingcheng: "访客行程",
  key_fangkerenzhengjilu: "访客认证记录",
  key_huiyishiguanli: "会议室管理",
  key_gongweiguanli: "工位管理",
  key_shebeiguanli: "设备管理",
  key_xitongshezhi: "系统设置",
  key_qiyeziliao: "企业资料",
  key_shezhi: "设置",
  key_xiugaimima: "修改密码",
  key_gerenxinxi: "个人信息",
  key_tuichu: "退出"
};

//公用
const common = {
  //概念
  key_baojing: "报警",
  key_shebei: "设备",

  //按钮类
  key_zanwushuju: "暂无数据",
  key_shangyibu: "上一步",
  key_xiayibu: "下一步",
  key_queren: "确认",
  key_quxiao: "取消",
  key_jieshu: "结束",
  key_guanbi: "关闭",
  key_wancheng: "完成",
  key_tijiao: "提交",
  key_yulan: "预览",
  key_quanbu: "全部",
  key_zidingyi: "自定义",
  key_chakan: "查看",
  key_xuhao: "序号",
  key_daochushuju: "导出数据",
  key_daochubiaogemingxi: "导出表格明细",

  //区域类
  key_weizhi: "位置",
  key_quyu: "区域",
  key_xuanzequyu: "选择区域",

  //比例类+数量类
  key_bili: "比例",
  key_leixing: "类型",

  key_zaixianshu: "在线数",
  key_zaixianlv: "在线率",
  key_qiyonglv: "启用率",
  key_guzhanglv: "故障率",
  key_chulilv: "处理率",
  key_chenggonglv: "成功率",
  key_pingjunzhi: "平均值",

  //时间段
  key_shijian: "时间",
  key_kaishiriqi: "开始日期",
  key_jieshuriqi: "结束日期",
  key_riqixuanze: "日期选择",
  key_Jan: "1月",
  key_Feb: "2月",
  key_Mar: "3月",
  key_Apr: "4月",
  key_May: "5月",
  key_Jun: "6月",
  key_Jul: "7月",
  key_Aug: "8月",
  key_Sep: "9月",
  key_Oct: "10",
  key_Nov: "11",
  key_Dec: "12",
  key_xuanzeyihuoduogeyuefen: "选择一个或多个月份",

  key_zuotian: "昨天",
  key_jinqitian: "近七天",
  key_jinsanshitian: "近30天",
  key_jinsangeyue: "近三个月",
  key_jinbannian: "近半年",
  key_benzhouqi: "本周期",
  key_bishangzhouqi: "比上周期",
  key_shangzhouqi: "上周期",
  key_zhouqi: "周期",
  key_shijianduan: "时间段",
  key_quanshijianduan: "全时间段",
  key_tongbishangzhou: "同比上周",

  //单位类
  key_danwei: "单位",
  key_shuliang: "数量",
  key_tai: "台",
  key_tiao: "条",
  key_ge: "个",
  key_fen: "分",
  key_tian: "天",
  key_yue: "月",
  key_xiaoshi: "小时",
  key_fenzhong: "分钟",
  key_miaozhong: "秒钟",

  key_yuan: "元",
  key_wanyuan: "万元",
  key_wan: "万",

  //状态
  key_zhuangtai: "状态",
  key_zhengchang: "正常",
  key_yichang: "异常",
  key_yiqiyong: "已启用",
  key_weiqiyong: "未启用",
  key_weichuli: "未处理",
  key_chulizhong: "处理中",
  key_yichuli: "已处理",
  key_zaixian: "在线",
  key_lixian: "离线",
  key_lianghao: "良好",
  key_yanzhong: "严重",
  key_zhongdeng: "中等",
  key_yiban: "一般",
  key_jiaocha: "较差",
  key_weizhixing: "未执行",
  key_yiwancheng: "已完成",
  key_weiwancheng: "未完成",
  key_zhixingzhong: "执行中",

  //placeholder 类
  key_qingshuru: "请输入",
  key_qingxuanze: "请选择",
  key_qingshangchuan: "请上传",

  //提示类
  key_cicaozuojiangshanchugairenwu: "此操作将删除该任务, 是否继续?",
  key_yiquxiaoshanchu: "已取消删除",
  key_tianjiarenwuchenggong: "添加任务成功",
  key_tianjiarenwushibai: "添加任务失败",
  key_bianjirenwuchenggong: "编辑任务成功",
  key_bianjirenwushibai: "编辑任务失败",
  key_shanchuchenggong: "删除成功",
  key_xiugaichenggong: "修改成功",
  key_tianjiachenggong: "添加成功",
  key_tianjiayingyonghouzaicaozuo: "请添加应用后再操作!",
  key_quedingshanchugangweileixing: "确定要删除该岗位类型吗？",
  key_changjingtishi1: "已到有效期",
  key_changjingtishi2: "已到有效期且已被禁用，",
  key_changjingtishi3: "已被禁用，",
  key_changjingtishi4: "若有更多需求请及时联系:400 000 6282",
  key_qingwanshanbiaogexinxi: "请完善表格信息",
  key_xinjianjuesechenggong: "新建角色成功",
  key_bianjijuesechenggong: "编辑角色成功"
};

// 项目概览
const projectOverviewLang = {
  key_danxiangmujiashicang: "单项目驾驶舱",
  key_quanxiangmujiashicang: "全项目驾驶舱",
  key_qiyongbili: "启用率统计比例图",
  key_zaixianbili: "在线率统计比例图",
  key_shebeibilifenxitu: "设备比例分析图",
  key_shebeixiaoxizongliang: "设备消息总量",
  key_shebeizongshu: "设备总数",
  key_xiaoxizongshu: "消息总数",
  key_gongdanxiangyingshijian: "工单响应时间",
  key_pingjunshijian: "平均时间",
  key_zuichangshijian: "最长时间",
  key_zuiduanshijian: "最短时间",
  key_shebeibaojing: "设备报警",
  key_shebeilixian: "设备离线",
  key_shebeizaixian: "设备在线",
  key_gongdandaizhixing: "工单待执行",
  key_baojingshujuchuli: "报警数据处理",
  key_daichuli: "待处理",
  key_yichuli: "已处理",
  key_jinyigeyuejingbaoshuju: "近30天报警数据趋势图",
  key_jinyigeyuenenghaoshuju: "近30天能耗数据趋势图",
  key_quanpingmoshi: "全屏模式",
  key_shebeijiankang: "设备健康",
  key_zongtiyunxing: "总体运行",
  //全项目驾驶舱页面
  key_jiashicang: "驾驶舱",
  key_quanbushebeishuliang: "全部设备数量",
  key_quanbuxiaoxishuliang: "全部消息数量",
  key_nenghaoqushitu: "能耗趋势图",
  key_baojingqushitu: "报警趋势图",
  key_yingyongfenbu: "应用分布",
  key_jieruyingyongzongshu: "接入应用总数",
  key_baojingbilitu: "报警比例图",
  key_yingyongdizhi: "应用地址",
  key_yingyongchuanjianshijian: "应用创建时间",
  key_shebeishuliang: "设备数量",
  key_xiaoxishuliang: "消息数量",
  key_xiangmuyunweizongrenshu: "项目运维总人数",
  key_gongdandaichulishuliang: "工单待处理数量",
  key_shebeibaojingshuliang: "设备报警数量",
  key_shebeilixianshuliang: "设备离线数量",
  key_qingshuruguanjianzi: "请输入关键字进行搜索",
  key_zonggongjiedian: "总共用电",
  Key_jieyueyongdian: "节约用电",
  key_yunweirenjunengxiaotisheng: "运维人均能效提升",
  key_zhongyangkongtiaozongjienenglv: "全部应用中央空调总节能率",
  key_bingxulengzongjienenglv: "全部应用冰蓄冷总节能率",
  key_quanbuyingyongpingjungongdan: "全部应用平均工单响应时间"
};

//设备管理
//1.设备总览
const deviceoverviewLang = {
  key_shebeizonglan: "设备总览",
  key_shebeizongshuUnit: "设备总数（台/个）",
  key_jinrituisongxiaoxishu: "今日推送消息数（次）",
  key_jinrixiafaminglingshu: "今日下发命令数（次）",
  key_jinrixinzengshebeishu: "今日新增设备数",
  //引用公用类
  key_wancheng: "完成",
  key_gexitongshebeiguzhangqushitu: "各系统设备故障趋势图",
  key_qingxuanzeshebeileixing: "请选择设备类型",
  key_shebeizongtiqingkuangfenxi: "设备总体情况分析",

  //系统分类菜单
  key_quanbuzailixianzhuangtai: "全部在/离线状态",
  key_quanbubaojingzhuangtai: "全部警报状态",
  key_baojingzhong: "报警中",
  key_zaixianzhuangtai: "在线状态",
  key_jingbaozhuangtai: "警报状态",
  key_zutaiyemian: "组态页面",
  key_caozuozhuangtai: "操作状态",
  key_diaoru: "调入",
  key_yaunchengkongzhi: "远程控制",
  key_kaiguan: "开/关",
  key_dingshikai: "定时开",
  key_dingshiguan: "定时关",

  //设备详情
  key_shebeixiangqing: "设备详情",
  key_jichuxinxi: "基础信息",
  key_suoshuleixing: "所属类型",
  key_ruwangshijian: "入网时间",
  key_shebeiID: "设备ID",
  key_shebeizhandian: "设备站点",
  key_xuliehao: "序列号",
  key_shebeierweima: "设备二维码",
  key_shebeidangan: "设备档案",
  key_zhixingjieguo: "执行结果",
  key_zerenren: "责任人"
};

//能耗管理
const energyConsumLang = {
  //1.总能耗统计
  key_nenghaofenbu: "能耗分布",
  key_zongnenghaotongji: "总能耗统计",
  key_yiji: "一级",
  key_suoxuan: "所选",
  key_quyunenghaoxiaofeiqingkuang: "区域能耗消费情况",
  key_shuifeizonglan: "水费总览",
  key_dianfeizonglan: "电费总览",

  //2.用水统计
  key_yongshuitongji: "用水统计",
  key_tongjifangshi: "统计方式",
  key_anfeiyong: "按费用",
  key_anyongliang: "按用量",

  //2.用电统计
  key_yongdiantongji: "用电统计",
  key_quedingyaoshanchu: "确定要删除",
  key_dangqianjigouxiayouzijigou:
    "当前机构下有子机构设置，删除 执行后将全部删除且不可恢复，仍要删除吗？"
};

//报警管理
const alarmManagementLang = {
  //1.实时报警

  key_baojingliebiao: "报警列表",
  key_shebeibaojing: "设备报警",
  key_shebeiyujing: "设备预警",
  key_yuxingyujing: "运行预警",
  key_chulizhuangtai: "处理状态",
  key_baojingjibie: "报警级别",
  key_chanpinleixing: "产品类型",

  key_baojingshijian: "报警时间",
  key_baojingneirong: "报警内容",
  key_shebeimingcheng: "设备名称",
  key_shebeiweizhi: "设备位置",
  key_chiixushijian: "持续时间",

  //2.报警分析

  key_baojingfenxi: "报警分析",
  key_baojingleixingfenxi: "报警类型分析",
  key_baojingpinjunchixushijian: "报警平均持续时间",

  key_baojinghuodongfenbu: "报警活动分布",
  key_leijishebeibaojingshu: "累计设备报警数",
  key_leijishebeiyujingshu: "累计设备预警数",
  key_leijiyunxingyujingshu: "累计运行预警数",
  key_baojingshu: "报警数",

  //3.报警定义
  key_baojingdingyi: "报警定义",
  //故障分析
  key_guzhangfenbu: "故障分布",
  key_shujufenxi: "数据分析",
  key_chufashijian: "触发时间",
  key_chixushijian: "持续时间",
  key_chufawentimingcheng: "触发问题名称",
  key_wentimiaoshu: "问题描述",
  key_kenengyuanyin: "可能原因",
  key_guzhangleibie: "故障类别",
  key_yanzhongchengdu: "严重程度",
  key_yingxiangfanwei: "影响范围",
  key_yunweijianyi: "运维建议",
  key_xinfengjizusongfeng: "新风机组送风温度异常",
  key_fjpgwenduguogao: "风机盘管区域温度过高",
  key_fjpgwenduguodi: "风机盘管区域温度过低",
  key_xinfengwubianhua: "新风机送风温度传感器读数24小时无变化",
  key_fenjiwubianhua: "风机盘管房间温度传感器读数24小时无变化",
  key_shebeixitong: "设备系统"
};

//维保管理
const maintenanceManagementLang = {
  //1.报警分析
  key_weibaofenxi: "维保分析",
  key_gongdantongji: "工单统计",
  key_quanbuweibaoleixing: "全部维保类型",

  key_weiwaiweixiu: "委外维修",
  key_weiwaijigai: "委外技改",
  key_dianxunjian: "点巡检",
  key_yuangongshangbao: "员工上报",

  key_gongdanzongshu: "工单总数",
  key_yichuligongdanshu: "已处理工单数",
  key_pingjungongdanchulishijian: "平均工单处理时间",

  key_gongdantongjiqushitu: "工单统计趋势图",
  key_gongdanchulijieguotongji: "工单处理结果统计",
  key_yuangongchuligongdan: "员工处理工单积极性排名",
  key_paiming: "排名",
  key_gongdanchulilv: "工单处理率",

  //2.当前任务
  key_dangqianrenwu: "当前任务",
  key_anweibaorenyuansousuo: "按维保对象/设备位置/分配人搜索",
  key_gongdanID: "工单ID",
  key_dongdanmingcheng: "工单名称",
  key_zuixinrenwubeizhu: "最新任务备注",
  key_zuixinchulijieguo: "最新处理结果",
  key_fenpeigongdan: "分配工单",
  key_peijianzhong: "配件中",
  key_weixiuzhong: "维修中",
  key_weibaoduixiang: "维保对象",
  key_weibaoleixing: "维保类型",
  key_weibaoneirong: "维保内容",
  key_fenpeizhi: "分配至",
  key_renwubeizhu: "任务备注",
  key_faqishijian: "发起时间",
  key_wanchengshijian: "完成时间",
  key_gongdanchuliliu: "工单处理流",
  key_zuixinfenpeizhi: "最新分配至",
  key_weibaogongdan: "维保工单",
  key_baoxiu: "报修",
  key_dianjianxunjian: "点检巡检",
  key_quanbugongdan: "全部工单",
  key_bukefenpei: "不可分配",
  key_kefenpei: "可分配",
  key_daizhixing: "待执行",

  //工单详情
  key_gongdanxiangqing: "工单详情",
  key_tijiaoren: "提交人",
  key_tijiaorenlianxifangshi: "提交人联系方式",

  //3.维保历史
  key_weibaolishi: "维保历史",
  key_quanbuchulijieguo: "全部处理结果",
  key_tiaoshichenggong: "调试成功",
  key_wubao: "误报",
  key_chulijieguo: "处理结果",

  //4.点检巡检
  key_anjihuamingchengsousuo: "按计划名称搜索",
  key_jihuamingcheng: "计划名称",
  key_xinzengdianxunjianjihua: "新增点巡检计划",
  key_bianjidianxunjianjihua: "编辑点巡检计划",
  key_zhixingzhuangtai: "执行状态",
  key_zhixing: "执行",
  key_quxiaozhixing: "取消执行",

  key_xuanzedianjianfanwei: "选择点检范围",
  key_xuanzedianjianleimu: "选择点检类目",
  key_xuanzeweihuxiang: "选择维护项",
  key_zhixingshijian: "执行时间",
  key_yuxuanze: "域选择",

  key_dianjianren: "点检人",

  key_weihuxiang: "维护项",
  key_jizhun: "基准",
  key_xunjianquyu: "巡检区域",

  //5.委外技改
  key_weiwaigongdan: "委外工单",
  key_quanburenwuleixing: "全部任务类型",
  key_quanbugongdanzhuangtai: "全部工单状态",
  key_daigenjin: "待跟进",
  key_genjinzhong: "跟进中",
  key_yiwancheng: "已完成",
  key_renwuleixing: "任务类型",
  key_gongdanzhuangtai: "工单状态",
  key_baojingxinxi: "报警信息",
  key_gongdanbeizhu: "工单备注",
  key_dianjian: "点检",
  key_xunjian: "巡检",
  key_kancha: "勘察",
  "key_anweibaoduixiang/shebeiweizhisousuo":
    "按维保对象/设备位置/分配人进行搜索",

  //6.报警任务分配
  key_baojingrenwufenpei: "报警任务分配",
  key_anshebeimingchengsousuo: "按设备名称/分配人进行搜索",
  key_zuihoubianjishijian: "最后编辑时间",

  //7.日常报事
  key_richangbaoshi: "日常报事",
  key_daifenpei: "待分配",
  key_yifenpei: "已分配",
  key_baoshineirong: "报事内容",
  key_baoshiwentixiangqing: "报事问题详情",
  key_antijaoren: "按提交人/提交人联系方式/分配人搜索",
  key_antijiao: "按提交人/提交人联系方式搜索",
  key_tijiaobumen: "提交部门",
  key_qingshurubeizhujianyi100zi: "请输入备注建议（100字以内）",
  key_beizhujianyi: "备注建议",
  key_caozuochenggong: "操作成功"
};

//运维通知
const noticeManagementLang = {
  //1.发布历史
  key_fabulishi: "发布历史",
  key_fabu: "发布",
  key_fabuxintongzhi: "发布新通知",
  key_tongzhizhuti: "通知主题",
  key_tongzhineirong: "通知内容",
  key_luokuanneirong: "落款内容",
  key_fabushijian: "发布时间",
  key_noticeWarning: "发布后将发送到全部用户APP内",
  key_fabuchenggong: "发布成功"
};

//系统配置
const systemSettinManagementLang = {
  //1.组织架构配置
  key_zuzhijiagoupeizhi: "组织架构配置",
  key_daoruzuzhijiagou: "导入组织架构",
  key_xinjianzijigou: "新建子机构",
  key_xinjiantongjijigou: "新建同级机构",
  key_kongjianpeizhi: "空间配置",

  //3.岗位类型配置
  key_gangweileixingpeizhi: "岗位类型配置",
  key_xinjiangangweileixing: "新建岗位类型",
  key_bianjigangweileixing: "编辑岗位类型",
  key_gangweileixingmingcheng: "岗位类型名称",
  key_peizhishijian: "配置时间",

  //4.水电费配置
  key_shuidianfeipeizhi: "水电费配置",
  key_dianfeipeizhi: "电费配置",
  key_shuifeipeizhi: "水费配置",
  key_gengxinpeizhitiaojian: "更新配置条件",
  key_tiaozhengdanjia: "调整单价",
  key_danjia: "单价",
  key_shiduan: "时段",
  key_digu: "低谷",
  key_pingduan: "平段",
  key_gaofeng: "高峰",
  key_jianfeng: "尖峰",
  key_jianfengyuefenshezhi: "尖峰月份设置",
  key_dianyajijiaqujian: "电压计价区间",
  key_quanshiduan: "全时段",
  key_peizhichenggong: "配置成功",
  key_suoyouxianweibitian: "所有项为必填项",
  key_xuanzeyigehuoduogeyue: "选择一个或多个月份",
  key_qingxiangengxinpeizhitiaojian: "请先更新配置条件"
};

const news = {
  key_xinwenliebiao: "新闻列表",
  key_fabuxinwen: "发布新闻",
  key_liulancishu: "浏览次数",
  key_xinwenzhuti: "新闻主题",
  key_xinwenneirong: "新闻内容",
  key_xinwenluesuotu: "新闻略缩图",
  key_tupian3m: "图片3M以内，支持.jpg、.jpeg、.png格式",
  key_shangchuantupiangeshi: "上传图片只能是JPG/JPEG/PNG 格式!",
  key_tupianbunengchaochu: "图片大小不能超过3MB!",
  key_tupianyaoqu: "上传图片只能是JPG/JPEG/GIF/PNG 格式!"
};

//个人中心
const personalSettingLang = {
  //更改公司信息
  key_genggaigongsixinxi: "更改公司信息",
  key_gongsixinxi: "公司信息",
  key_suozaiquyu: "所在区域",
  key_gexingshezhitishi1: "若公司信息有更新，请发送邮件到",
  key_gexingshezhitishi2: "博彦物联网运维人员收到邮件后，会及时与您联系并核实",

  //个性配置
  key_pingtailogo: "平台logo",
  key_xuanzepingtaizhusediao: "选择平台主色调",
  key_shebeijierupingtaimingcheng: "设备接入平台名称",
  key_dapingxianshimingcheng: "大屏显示名称",
  key_qingshurupingtaimingcheng: "请输入平台名称",
  key_15zifuyinei: "15字符以内",
  key_10zifuyinei: "10字符以内",
  key_18zifuyinei: "18字符以内",
  key_tupianzhinengweiPNGgeshi: "图片只能是PNG格式!",
  key_tupiandaxiao3M: "图片大小不能超过3MB!",
  "key_tupiankuangaowei38*38": "图片宽高必须是38*38!",
  key_gexingshezhitishi3:
    "图片像素为38像素*38像素，大小不超过3M，.png格式的logo"
};

// 员工管理
const staffManagement = {
  //角色
  key_APPgongnengquanxianliebiao: "APP功能权限列表",
  key_dibudaohang: "底部导航",
  key_duiyingzicaidan: "对应子菜单",
  key_peizhigongneng: "+ 配置功能",
  key_xuanzepeizhimokuai: "选择配置模块",
  key_dibuxuanzemokuaitishi1: "底部导航最少选择2个模块",
  key_dibuxuanzemokuaitishi2: "底部导航最多选择5个模块",
  key_houtaiyonghu: "后台用户",
  key_yonghudenglumima: "用户登录密码",
  key_qingshuruyonghudenglumima: "请输入用户登录密码",
  key_xinjianzhanghu: "新建账户",
  key_bianjizhanghu: "编辑账户",
  key_zhanghuxinxi: "账户信息",
  key_youxiang: "邮箱",
  key_juese: "角色",
  key_chuangjianchenggong: "创建成功",
  key_qingxuanzejuese: "请选择角色",
  key_shifouyaoshanchugaizhanghu: "确认要删除该账户吗？",
  zhanghu: "账户",
  key_querenjinyongma: "确定要禁用该账号吗？",
  key_querenqiyongma: "确定要启用该账号吗？",
  key_jinyongchenggong: "禁用成功！",
  key_qiyongchenggong: "启用成功！",
  key_yuangongliebiao: "员工列表",
  key_jiansuotiaojian: "检索条件",
  key_yuangonggonghao: "员工工号",
  key_xingming: "姓名",
  key_gangweileixing: "岗位类型",
  key_gongzuoquyu: "工作区域",
  key_renliancaijizhuangtai: "人脸采集状态",
  key_chuangjianshijian: "创建时间",
  key_quanbu: "全部",
  key_yicaiji: "已采集",
  key_weicaiji: "未采集",
  key_yuangongxingming: "员工姓名",
  key_renzhengzhuangtai: "认证状态",
  key_yirenzheng: "已认证",
  key_weirenzheng: "未认证",
  key_renzhengzhong: "认证中",
  key_renzhengshibai: "认证失败",
  key_sousuo: "搜索",
  key_xinjian: "新建",
  key_bianji: "编辑",
  key_shanchu: "删除",
  key_daochushuju: "导出数据",
  key_zhongwenxingming: "中文姓名",
  key_xingbie: "性别",
  key_zaizhizhuangtai: "在职状态",
  key_shoujihaoma: "手机号码",
  key_suoshubumen: "所属部门",
  key_bangongdidian: "办公地点",
  key_caozuo: "操作",
  key_gong: "共",
  key_ye: "页",
  key_tiaoshuju: "条数据",
  key_meiyexianshi: "每页显示",
  key_xianshiquanbushuju: "显示全部数据",
  key_zaizhi: "在职",
  key_lizhi: "离职",
  key_qingxuanzeyuangonghouzaijinxingshanchu: "请至少选择一项后再进行删除！",
  key_shifouyaoshanchusuoxuanyuangong: "是否要删除所选员工?",
  key_tishi: "提示",
  key_queding: "确定",
  key_quxiao: "取消",
  key_shanchuyuangong: "删除员工",
  key_daochuyuangong: "导出员工",
  key_daoruyuangong: "导入员工",
  key_jinengbiaoqian: "技能标签",
  key_shizifuyinei: "10字符以内",
  key_xingmingshoujihaoyouxiang: "按姓名/手机号/邮箱搜索"
};
// 会议室管理
const conferenceRoomManagement = {
  "el.cascader.noData": "暂无数据",
  key_huiyishiID: "会议室ID",
  key_chuanjianren: "创建人",
  key_huiyishimingcheng: "会议室名称",
  key_huiyishiweizhi: "会议室位置",
  key_dangqianzhuangtai: "当前状态",
  key_anhuiyishisheshisousuo: "按会议室名称/配置设施搜索",
  key_kongxian: "空闲",
  key_shiyongzhong: "使用中",
  key_peizhisheshi: "配置设施",
  key_huiyishibianhao: "会议室编号",
  key_sheshipeizhi: "设施配置",
  key_shifouqiyong: "是否启用",
  // 新建会议室
  key_qingshuruhuiyishimingcheng: "请输入会议室名称（15字以内）",
  key_qingxuanzehuiyishiweizhi: "请选择会议室位置",
  key_shezhiyudingshijian: "设置预定时间",
  key_huiyishikeyudingshijian: "会议室可预定时间",
  key_qingshuruzhengzhengshu: "请输入整数数字",
  key_huiyiyuyuexiangqing: "会议预约详情",
  key_shifouyaoshanchugaihuiyishi:
    "删除后，此会议室将不能使用。请确认是否删除？",
  key_shezhichenggong: "设置成功！",
  // 预约详情
  key_xinjianhuiyishi: "新建会议室",
  key_bianjihuiyishi: "编辑会议室",
  key_huiyishixinxi: "会议室信息",
  key_yuyuexiangqing: "预约详情",
  key_shiyongzhe: "使用者",
  key_suoshugongsi: "所属公司",
  key_yuyueren: "预约人",
  key_yuhuizhe: "与会者",
  key_huiyimudi: "会议目的",
  key_weikaishi: "未开始",
  key_shiyongzhong: "使用中",
  key_shiyongwancheng: "使用完成",
  key_quxiao_weishiyong: "取消（未使用）",
  key_quxiao_tiqianshifang: "取消（提前释放）",
  key_quxiao_yiguoqi: "取消（已过期）"
};

// 工位管理
const locationManagement = {
  key_gongweiguanli: "工位管理",
  key_gongweimingcheng: "工位名称",
  key_gongweibianhao: "工位编号",
  key_bangongshimingcheng: "办公室名称",
  key_xinjiangongwei: "新建工位",
  key_bianjigongwei: "编辑工位",
  key_gongweiweizhi: "工位位置",
  key_angongweimingchengsheshisousuo: "按工位名称/配置设施搜索",
  key_qingxuangongweiweizhi: "请选择工位位置",
  key_qingshurugongweimingcheng: "请输入工位名称（20字以内）",
  key_qingxuanzegongweiweizhi: "请选择工位位置",
  key_gongweixinxi: "工位信息",
  key_gongweixiangqing: "工位详情",
  key_yuyuerenshoujihao: "预约人手机号",
  key_yuyueshijian: "预约时间",
  key_shifouyaoshanchugaigongwei: "确定要删除该工位吗?",
  key_gongweiikeyudingshijian: "工位可预定时间",
  key_shezhigongweihuanjingcelue: "设置工位环境策略",
  key_shezhihuanjingcelue: "设置工位环境策略",
  key_qiandao: "签到",
  key_jieshushiyong: "结束使用",
  key_likai: "离开",
  key_yiquxiao: "已取消",
  key_qingxuanzewangguan: "请选择网关",
  key_qingxuanzeshebei: "请选择设备",
  key_guanlianshebei: "关联设备",
  key_shiyongzhe: "使用人/预约人",
  key_keyuyue: "可预约",
  key_yiyuyue: "已预约",
  key_yizhanyong: "已占用",
  key_bukeyong: "不可用",
  // 工位智能设备
  key_gongweishebeiguanli: "工位设备管理",
  "key_tianjiawangguan-shebei": "添加网关-设备",
  key_wangguanzhuangtai: "网关状态",
  key_anwanggguanimingchengdizhisousuo: "按网关名称/网关地址搜索",
  key_tianjiashijian: "添加时间",
  key_wangguansheibeishu: "网关设备数",
  key_wangguanzhuangtai: "网关状态",
  key_wangguandizhi: "网关地址",
  key_wangguanmingcheng: "网关名称",
  key_wangguanweizhi: "网关位置",
  key_chakanwangguanshebei: "查看网关设备",
  key_xinjianwangguanshebei: "新建网关设备",
  key_bianjiwangguanshebei: "编辑网关设备",
  key_qingshurubeizhu100zi: "请输入备注（100字以内）",
  key_qingshuruwangguandizhi: "请输入网关地址",
  key_qingshuruwangguanmingcheng: "请输入网关名称",
  key_qingxuanzewangguanweizhi: "请选择网关位置",

  //停车场管理
  key_tingchechangmingcheng: "停车场名称",
  key_tingchechangguanli: "停车场管理",
  key_tingchechangtupian: "停车场图片",
  key_qingshurutingchechangmingcheng: "请输入停车场名称",
  key_tingchechangtupianyanzheng:
    "大小不超过3M，图片格式为.jpg、.jpeg、.png、.gif",
  key_qingshangchuantingchechangtupian: "请上传停车场图片",

  //车位管理
  key_gudingcheweiguanli: "固定车位管理",
  key_fangkecheweiguanli: "访客车位管理 ",
  key_shouquanzhong: "授权中",
  key_shoujihaoxingmingchepaihao: "手机号/车牌号/姓名",
  key_fangkelianxirenfangkeshoujihaochepaihao: "访客联系人/访客手机号/车牌号",
  key_shoujihao: "手机号",
  key_fangshi: "方式",
  key_shouquanchewei: "授权车位",
  key_shouquan: "授权",
  key_quxiaoshouquan: "取消授权",

  key_jiedairenshoujihao: "接待人手机号",
  key_fangkelianxiren: "访客联系人",
  key_mudi: "目的",
  key_tongyi: "同意",
  key_jujue: "拒绝",
  key_tijiaoshijian: "提交时间",
  key_beizhu: "备注",
  key_daishenhe: "待审核",
  key_shenhezhong: "审核中",
  key_yitongyi: "已同意",
  key_yijujue: "已拒绝",
  key_chepaihao: "车牌号",
  key_shouquanshijian: "授权时间",
  key_dangqianchepaihao: "当前车牌号",
  key_shifouquedingjujuegaichepaihao: "是否确定拒绝该车牌号?",
  key_shifouquedingquxiaoshouquan: "是否确定取消授权?",
  key_shifouquedingshanchugaichepaihao: "是否删除该车牌号?",
  key_APPtijiao: "APP提交",
  key_houtaichuangjian: "后台创建",
  key_xiangqing: "详情",
  key_qingshuruchepaihao: "请输入车牌号",
  key_ruchangshijian: "入场时间",
  key_chuchangshijian: "出场时间",
  key_tingcheshichang: "停车时长",
  key_cheliangleixing: "车辆类型",
  key_chepaihaoxingming: "车牌号/姓名 ",
  key_gudingchewei: "固定车位",
  key_fangkechewei: "访客车位",
  key_qitachewei: "其他车位",
  key_quxiaozhong: "取消中",
  key_shouquanshibai: "授权失败"
};

// 新建/编辑员工
const newStaff = {
  key_xinjianyuangong: "新建员工",
  key_bianjiyuangong: "编辑员工",
  key_piliangshanchu: "批量删除",
  key_jibenxinxi: "基本信息",
  key_suoshuzuzhi: "所属组织",
  key_yingwenxingming: "英文姓名",
  key_xingbie: "性别",
  key_nan: "男",
  key_nv: "女",
  key_gangwei: "岗位",
  key_yuangongleixing: "员工类型",
  key_ruzhiriqi: "入职日期",
  key_gerenyouxiang: "个人邮箱",
  key_APPmima: "APP密码",
  "key_8~16weishuzi,zimuhunhe": "8~16位数字，大小写字母,特殊字符组合",
  key_zaicishurumima: "再次输入密码",
  key_renzhengxinxi: "认证信息",
  key_renlianxinxi: "人脸信息",
  key_menjinrenzheng: "门禁认证",
  key_baocun: "保存",
  key_quxiao: "取消",
  key_fanhui: "返回",
  key_jianzhiyuangong: "兼职员工",
  key_quanzhizhengshiyuangong: "全职正式员工",
  key_lizhi: "离职",
  key_zaizhi: "在职",
  key_xuanzeriqi: "选择日期",
  key_yuangongxinxi: "员工信息",
  key_riqi: "日期",
  key_tongxingjilu: "通行记录",
  key_qingshuruyuangongweiyihao: "请输入员工唯一号",
  key_qingshurushoujihaoma: "请输入手机号码",
  key_qingshurugerenyouxiang: "请输入邮箱",
  key_qingshuruAPPmima: "请输入APP密码",
  key_qingzaicishurumima: "请再次输入密码",
  key_qingxuanzegongzuoquyu: "请选择工作区域",
  key_qingshuruyuangonggonghao: "请输入员工工号（纯数字）",
  key_qingshuruxingming: "请输入姓名",
  key_bumen: "部门",
  key_shoujihaobunengweikong: "手机号不能为空",
  key_qingshuruzhengquedeshoujihao: "请输入正确的手机号",
  key_qingshuruchunshuzi: "请输入纯数字的员工工号",
  key_yungonggonghaobunengweikong: "员工工号不能为空",
  key_qingxuanzezaizhizhuangtai: "请选择在职状态",
  key_qingxuanzegangweileixing: "请选择岗位类型",
  key_qingxuanzeyuangong: "请选择员工",
  key_qingxuanzesuosubumen: "请选择所属部门",
  key_qingxuanzegongzuoquyu: "请选择工作区域",
  key_qingshurushoujihao: "请输入手机号",
  key_qingshuruzhengquedeyouxiang: "请输入正确的邮箱",
  key_qingshuruzhongwenxingming: "请输入中文姓名",
  key_qingshurumima: "请输入密码",
  key_qingchongfushurumima: "请重复输入密码",
  key_liangcishurudemimabuyizhi: "两次输入的密码不一致",
  key_tianjiachenggong: "创建成功",
  key_bianjichenggong: "编辑成功",
  key_fenpeichenggong: "分配成功",
  key_riqibunengweikong: "日期不能为空"
};

// 访客管理
const visitorManagement = {
  key_fangkeguanli: "访客管理",
  key_shenqingren: "申请人",
  key_shenqingriqi: "申请日期",
  key_fangkelianluoren: "访客联络人",
  key_fangkeleixing: "访客类型",
  key_fangkexingchengID: "访客行程ID",
  key_jiedairen: "接待人",
  key_kaishishijian: "开始时间",
  key_jieshushijian: "结束时间",
  key_fangkerenshu: "访客人数",
  key_laifangmudi: "来访目的",
  key_shenqingrenxinxi: "申请人信息",
  //查看访客行程
  key_fangkexingchengxinxi: "访客行程信息",
  key_fangkexingcheng: "查看访客行程",
  key_jiedairenshoujihaoma: "接待人手机号码",
  key_fangkeshoujihao: "访客手机号码",
  key_fangkezhengjian: "访客证件类型",
  key_zhengjianhaoma: "证件号码",
  key_laikerenshu: "来客人数",
  key_chepaihao: "车牌号",
  key_shifouxianshihuanyingci: "是否显示欢迎词",
  key_huanyingci: "欢迎词",
  key_fangkezidongzhongduan: "访客自动终端设备",
  key_caijifangkexinxi: "采集访客行程",
  key_fangkexingming: "访客姓名",
  key_fangkezhaopian: "访客照片",
  key_weikaishi: "未开始",
  key_jinxingzhong: "进行中",
  key_yijieshu: "已结束",
  key_caijifangkerenshu: "采集访客人数",
  key_shenfenzheng: "身份证",
  key_jiluId: "记录ID",
  // 访客认证记录
  key_fangkeleixing: "访客类型",
  key_xingchengID: "行程ID",
  key_tongxingfangshi: "通行方式",
  key_diyicitongxingshijian: "第一次通行时间",
  key_zuihouyicitongxingshijian: "最后一次通行时间",
  key_anshenqingrenfangkelianluorensousuo: "按申请人/访客联系人搜索",
  key_yuyuefangke: "预约访客",
  key_yaoyuefangke: "邀约访客"
};

// 员工授权记录
const empowerPeople = {
  key_qingkong: "清空",
  key_shouquanzhuangtai: "授权状态",
  key_shebeibianhao: "设备编号",
  key_quyubianhao: "区域编号",
  key_bangongshibianhao: "办公室编号",
  key_yishouquan: "已授权",
  key_weishouquan: "未授权"
};

// 通用设置
const generalSettings = {
  key_tongyongshezhi: "通用设置",
  key_xianshishijianshezhi: "显示时间设置",
  key_huanyingpingtiqianxianshishijian: "欢迎屏提前显示时间（分钟）",
  key_huanyingpingyanhouxianshishijian: "欢迎屏延后显示时间（分钟）",
  key_huanyingpingyanhoujieshuxianshishijian: "欢迎屏延后结束显示时间",
  key_huiyishitiqianxianshishijian: "会议室提前显示时间（分钟）",
  key_huiyishiyanhouxianshishijian: "会议室延后显示时间（分钟）",
  key_gongweitiqianxianshishijian: "工位提前显示时间（分钟）",
  key_jienengshijianshezhi: "节能时间设置",
  key_huiyishitiqianganyingshijian: "会议室提前感应时间（分钟）",
  key_gongweiqishenganyingshijian: "工位起身感应时间（分钟）",
  key_huanyingpingbeijingshezhi: "欢迎屏背景设置",
  key_tupianchicunwei19201200JPGPNGgeshi: "图片尺寸为1920*1200,JPG/PNG格式",
  key_shangchuantupian: "上传图片",
  key_tijiao: "提交",
  key_tupianshangchuanchenggong: "图片上传成功",
  key_baocunchenggong: "保存成功",
  key_baocunshibai: "保存失败",
  key_shangchuangeshijinweiAPKdaxiao100MB: "上传格式仅为APK, 大小100MB",
  key_dangqianxianzhixuanze3gewenjianbencixuanzele:
    "当前限制选择 3 个文件，本次选择了",
  key_gewenjiangongxuanzele: "个文件，共选择了",
  key_gewenjian: "个文件",
  key_yonghuanzhuangbao: "用户安装包",
  key_fangkerenzhengshenqinganzhuangbao: "访客认证安装包",
  key_quedingyichu: "确认移除",
  key_jiangwenjiantuodaocichuhuo: "将文件拖到此处,或 ",
  key_dianjishangchuan: "点击上传",
  key_anzhuangbaoshezhi: "安装包设置",
  key_shangchuanshijian: "上传时间",
  key_dangqianbanben: "当前版本",
  key_dianjitupianshangchuan: "点击图片上传",
  key_shangchuanchenggong: "上传成功",
  key_shangchuanshibaibanbenguicecuowu: "上传失败,版本规则错误"
};
// 其他
const rests = {
  key_jinggao: "warning",
  key_qingxuanzeshijianduan: "Please select time period",
  key_shi: "是",
  key_fou: "否",
  key_lianjiechaoshi: "连接超时",
  key_yuyan: "语言",
  key_zhongwen: "中文",
  key_yingwen: "英文"
};

// 角色
const roleList = {
  key_juese: "角色",
  key_zhuangtai: "状态",
  key_qingshurujuesemingcheng: "请输入角色名称（15字以内）",
  key_qingshurujuesemingcheng1: "请输入角色名称",
  key_qingshurujuesemiaoshu: "请输入角色描述（30字以内）",
  key_anjuesemingchengsousuo: "按角色名称搜索",
  key_juesemingcheng: "角色名称",
  key_juesemiaoshu: "角色描述",
  key_xinjianjuese: "新建角色",
  key_qiyong: "启用",
  key_jinyong: "禁用",
  key_bianji: "编辑",
  key_peizhiquanxian: "配置权限",
  key_querenjinyongjuesema: "确定要禁用该角色吗？",
  key_querenqiyongjuesema: "确定要启用该角色吗？",
  key_shifouyaoshanchugaijuese: "确定要删除该角色吗？",
  key_juesexinxi: "角色信息",
  key_shuoming: "说明：左侧选择企业应用（可多选),右侧为其对应的功能权限配置。",
  key_xuanzeyingyong: "选择应用",
  key_duiyinggongnengquanxian: "对应功能权限",
  key_peizhiquanxianchenggong: "配置权限成功",
  key_qingxuanzeyingyong: "请选择应用",
  key_qingxuanzequanxian: "请选择权限",
  key_zanwuyingyongqingxianjian: "暂无应用，请先新建应用！"
};
// 设备管理
const deviceManagement = {
  key_shebeiguanli: "Device Management",
  key_shebeizhuangtai: "Device Status",
  // 'key_beizhu': 'Description',
  key_zhengchang: "正常",
  key_shilian: "missing"
};
export default {
  login, //登录
  headerLang, //头部导航栏
  Aside, //左侧导航栏
  common, //公用
  projectOverviewLang, //项目概览
  deviceoverviewLang, //设备管理
  energyConsumLang, //能耗管理
  alarmManagementLang, //报警管理
  maintenanceManagementLang, //维保管理
  noticeManagementLang, //运维通知
  systemSettinManagementLang, //系统配置
  personalSettingLang, //个人中心
  news,
  staffManagement,
  newStaff,
  empowerPeople,
  visitorManagement,
  conferenceRoomManagement,
  locationManagement,
  generalSettings,
  deviceManagement,
  rests,
  roleList
};



// WEBPACK FOOTER //
// ./src/assets/lang/cn.js